export default "__VITE_ASSET__6NpOe9n0jeRY_FVLYNKmYg__"